import { createFileRoute } from "@tanstack/react-router";
import HighmarkBlueShieldNeNyInsurance, {
  config,
} from "@/pages/HighmarkBlueShieldNeNyInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/highmark-blue-shield-ne-ny-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Highmark Blue Shield NE NY TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how Highmark Blue Shield of Northeastern New York policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content: "Highmark Blue Shield NE NY TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how Highmark Blue Shield of Northeastern New York policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/highmark-blue-shield-ne-ny-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/highmark-blue-shield-ne-ny-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HighmarkBlueShieldNeNyInsurance />;
}
